export const MINIMUM_POST_COUNT_RECOMMENDATION = 10;
